import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { App } from '@/app/App';
import '@/shared/styles/global.css';
import '@/shared/styles/workspace.css';
import { AppErrorBoundary } from '@/app/AppErrorBoundary';

function RouteAwareErrorBoundary({ children }: { children: React.ReactNode }): JSX.Element {
  const location = useLocation();
  return <AppErrorBoundary resetKey={location.key}>{children}</AppErrorBoundary>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <RouteAwareErrorBoundary>
        <App />
      </RouteAwareErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);
